/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MinDownpayment/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers'
import InputSmallLabel from 'DesignSystem/InputSmallLabel/index'
import React from 'react'
import ToggleLabels from 'DesignSystem/ToggleLabels/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MinDownpayment({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/CustomPlan/MinDownpayment",
  onChange,
  textNo = "$"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let rulesetCustomPaymentPlanRulesetMinDownpaymentValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.min_downpayment',
})
let rulesetCustomPaymentPlanRulesetMinDownpaymentChangeData = fromData.useDataChange({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.min_downpayment',
})
let rulesetCustomPaymentPlanRulesetMinDownpaymentTypeValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.min_downpayment_type',
})
let constantData = 'amount'
let aggregateData = fromAggregate.equals(rulesetCustomPaymentPlanRulesetMinDownpaymentTypeValueData, constantData)
let rulesetCustomPaymentPlanRulesetMinDownpaymentTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.min_downpayment_type',
})
let constantData1 = 'percentage'
let aggregateData1 = fromAggregate.equals(rulesetCustomPaymentPlanRulesetMinDownpaymentTypeValueData1, constantData1)
let onClickNo = fromHelpers.useOnClickNo({
  children,
  viewPath,
  onChange,
  textNo
  
})
let onClickYes = fromHelpers.useOnClickYes({
  children,
  viewPath,
  onChange,
  textNo
  
})
  return (<React.Fragment
>
<div
  data-testid="MinDownpayment.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-ZqAmTv': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<InputSmallLabel
  viewPath={`${viewPath}/InputSmallLabel`}
 label="minimum downpayment"
 type="number"
 data="ruleset.custom_payment_plan_ruleset.min_downpayment"
 onChange={rulesetCustomPaymentPlanRulesetMinDownpaymentChangeData}
 value={rulesetCustomPaymentPlanRulesetMinDownpaymentValueData}
/>
<ToggleLabels
  viewPath={`${viewPath}/ToggleLabels`}
 paddingTop={10}
 paddingBottom={10}
 data="ruleset.custom_payment_plan_ruleset.min_downpayment_type"
 data="'amount'"
 aggregate="/Data/aggregate.js equals"
 isSelectedNo={aggregateData}
 onClickNo={onClickNo}
 textNo={textNo}
 data="ruleset.custom_payment_plan_ruleset.min_downpayment_type"
 data="'percentage'"
 aggregate="/Data/aggregate.js equals"
 isSelectedYes={aggregateData1}
 onClickYes={onClickYes}
 textYes="%"
/>
</div>
{children}
</React.Fragment>)
}